import { useProfile } from '../api';

export const useActiveCompany = () => {
  const { profile } = useProfile();

  return profile?.companies[0];
};
